export default "__VITE_ASSET__Ea1neAUY__$_?url__"